import { Alert, EmptyState, InfiniteScrollTrigger, Skeleton, Stack } from '@all-manager/design-system-v2';
import NoHistoryIcon from "../../assets/no-historic.svg?react";
import type { CommunicationKind } from "../../api/useGetCommunications";
import CommunicationCard from "./CommunicationCard";
import { useCommunicationsTab } from "./useCommunicationsTab";

type Props = {
  subTopicId?: string;
  providerId?: string;
  kind?: CommunicationKind;
};

const SKELETON_ROWS = [0, 1, 2];

export default function CommunicationsTab(props: Props) {
  const {
    communications,
    isLoading,
    error,
    hasMore,
    isLoadingMore,
    isLoadMoreError,
    handleLoadMore,
    emptyState,
    loadingLabel,
    errorLabel,
    loadMoreLabel,
  } = useCommunicationsTab(props);

  return (
    <>
      {isLoading ? (
        <Stack spacing={2} aria-busy="true" aria-label={loadingLabel}>
          {SKELETON_ROWS.map((row) => (
            <Skeleton key={row} variant="rounded" height={88} />
          ))}
        </Stack>
      ) : error ? (
        <Alert severity="error">
          {errorLabel}
        </Alert>
      ) : communications.length === 0 ? (
        <EmptyState
          title={emptyState.title}
          subtitle={emptyState.subtitle}
          image={<NoHistoryIcon />}
        />
      ) : (
        <Stack spacing={2}>
          {communications.map((item) => (
            <CommunicationCard key={item.id} item={item} />
          ))}
          <InfiniteScrollTrigger
            hasMore={hasMore}
            isLoading={isLoadingMore}
            isError={isLoadMoreError}
            onLoadMore={handleLoadMore}
            label={loadMoreLabel}
          />
        </Stack>
      )}
    </>
  );
}
